import React from 'react'
import { connect } from 'react-redux'
import { StyledSection } from './mHero.style'
import * as pageActions from 'form/store/page/actions'

import {
  ThemeProvider,
  Breakpoints,
  BreakpointWrapper,
  Layout,
  Text,
  TextColor,
  TextAppearance,
  TextAlignment
} from '@volkswagen-onehub/components-core'

const Hero = ({
  heroImageMobile,
  heroImageDesktop,
  text,
  textAlignment = 'left'
}) => (
  <>
    <BreakpointWrapper max={Breakpoints.tablet}>
      <StyledSection>
        <Layout
          appearance={{
            [Breakpoints.default]: [
              { name: 'a', columns: 24 },
              { name: '.', columns: 2 },
              { name: 'b', columns: 20 },
              { name: '.', columns: 2 }
            ]
          }}
        >
          <div className="image-wrapper">
            <img src={heroImageMobile} alt={text} />
          </div>
          {console.log('textAlignment', textAlignment)}
          <Text
            tag="h2"
            color={TextColor.primary}
            appearance={TextAppearance.headline400}
          >
            {text}
          </Text>
        </Layout>
      </StyledSection>
    </BreakpointWrapper>
    <ThemeProvider theme="inverted">
      <BreakpointWrapper min={Breakpoints.tablet}>
        <StyledSection imageSrc={heroImageDesktop}>
          <Layout
            appearance={{
              [Breakpoints.default]: [
                { name: '.', columns: 2 },
                { name: 'a', columns: 20 },
                { name: '.', columns: 2 }
              ]
            }}
          >
            <Text
              tag="h3"
              color={TextColor.primary}
              appearance={TextAppearance.headline400}
              bold
              textAlign={TextAlignment[textAlignment]}
            >
              {text}
            </Text>
          </Layout>
        </StyledSection>
      </BreakpointWrapper>
    </ThemeProvider>
  </>
)

const mapStateToProps = ({ page }) => {
  const { cmsdata } = page
  const { hero } = cmsdata.data.pages.homePage
  const { heroImageMobile, heroImageDesktop, text, textAlignment } = hero

  return {
    heroImageMobile,
    heroImageDesktop,
    text,
    textAlignment
  }
}

export default connect(mapStateToProps, { ...pageActions })(Hero)
